const getPuzzle = async (wordCount) => {
    const response = await fetch(`//puzzle.mead.io/puzzle?wordCount=${wordCount}`)

    if (response.status === 200) {
        const data = await response.json()
        return data.puzzle
    } else {
        throw new Error("Unable to fetch puzzle")
    }
}

const getCountry = async (countryCode) => {
    const response = await fetch("//restcountries.eu/rest/v2/all", {})

        if(response.status === 200) {
            const data = await response.json()
            const country = data.find((country) => country.alpha2Code === countryCode)
            return country 
        } else {
            throw new Error("Unable to fetch data")
        }
}

const getLocation = async () => {
    const response = await fetch("//ipinfo.io?token=47bfd9a6ed8ab7")
        
    if(response.status === 200) {
            return response.json()
        } else {
            throw new Error("Unable to fetch data")
        }
}

const getCurrentCountry = async () => {
    const countryCode = await getLocation()
    const countryName = await getCountry(countryCode.country)
    return countryName
}

export { getPuzzle as default }


